import debounce from "lodash.debounce";
import { DependencyList, useCallback } from "react";

const debounceCallback = (wait: number, deps?: DependencyList) => {
  return (callback: (...props: any) => void) =>
    useCallback(debounce(callback, wait), deps || []);
};

export default debounceCallback;
